import React, { useState, useEffect } from 'react';

const InteractiveOverlay = () => {
  const [showElectronicsOverlay, setShowElectronicsOverlay] = useState(false);
  const [showFireOverlay, setShowFireOverlay] = useState(false);

  const handleKeyPress = (event) => {
    if (event.key === 'e') {
      setShowElectronicsOverlay(prevState => !prevState);
    } else if (event.key === 'f') {
      setShowFireOverlay(prevState => !prevState);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);

    // Cleanup the event listener
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <div>
      {showElectronicsOverlay && (
        <div className="overlay-text-box">
          <p>👋 Electronics Bench here, how may I help you? 🔋</p>
          <input type="search" placeholder="Search..." />
        </div>
      )}

      {showFireOverlay && (
        <div className="overlay-text-box">
          <p>Let's talk about lab safety! 🔥</p>
          <input type="search" placeholder="Search..." />
        </div>
      )}
    </div>
  );
};

export default InteractiveOverlay;
